import { useMutation } from '@apollo/client';

import Client from 'helpers/queries/query.client';

const useLogout = () => {
  const [logoutMutation, logoutMutationInfo] = useMutation(Client.MUTATION_LOGOUT);

  const logOut = async () => {
    if (logoutMutationInfo && logoutMutationInfo.called) {
      console.log('...trying to log out ...');
      return logoutMutationInfo;
    } else {
      try {
        console.log('starting log out...');
        await logoutMutation();
        return logoutMutationInfo;
      } catch (e) {
        console.error('logout on server error');
        throw e;
      }
    }
  };

  return { logOut };
};

export default useLogout;
